var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125ZM1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10ZM10.3914 6.22472C10.6355 5.98065 11.0312 5.98065 11.2753 6.22472L14.6086 9.55806C14.8527 9.80214 14.8527 10.1979 14.6086 10.4419L11.2753 13.7753C11.0312 14.0194 10.6355 14.0194 10.3914 13.7753C10.1473 13.5312 10.1473 13.1355 10.3914 12.8914L12.6578 10.625H5.83333C5.48816 10.625 5.20833 10.3452 5.20833 10C5.20833 9.65482 5.48816 9.375 5.83333 9.375H12.6578L10.3914 7.10861C10.1473 6.86453 10.1473 6.4688 10.3914 6.22472Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.078da7e587237a2d4ec0362748cc21f5.svg";
export { ForwardRef as ReactComponent };